import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/dash')({
  component: RouteComponent,
})

function RouteComponent() {
  return <div>Hello "/_authenticated/dash"!</div>
}
